import { Controller } from '@hotwired/stimulus'
import { on, off } from '../lib/events'

export default class extends Controller {
  static values = { float: String }
  static targets = ['image']

  imageTargetConnected = (target) => {
    if (target.complete) {
      this.setFrame()
    }
    else {
      target.addEventListener('load', this.setFrame)
    }
  }

  connect = () => {
    on('resize', this.resetStyles)
  }

  disconnect = () => {
    off('resize', this.resetStyles)
  }

  setFrame = () => {
    this.element.style.width = ''
    this.element.style.height = ''
    const { paddingLeft, paddingRight, paddingTop, paddingBottom } = window.getComputedStyle(this.element)

    this.element.style.borderLeftWidth = paddingLeft
    this.element.style.borderRightWidth = paddingRight
    this.element.style.borderTopWidth = paddingTop
    this.element.style.borderBottomWidth = paddingBottom
    this.element.style.padding = '0%'
  }

  resetStyles = () => {
    this.element.style.padding = this.framePercent
    this.element.style.borderWidth = ''
    this.setFrame()
  }

  get framePercent() {
    return `${parseFloat(this.floatValue) * 100}%`
  }
}
